import { Dispatch } from "redux";
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import jwtAxios from "../../@crema/services/auth/jwt-auth";
import { AppActions } from "types";
import { AxiosResponse } from "axios";
import { CREATE_CMS, GET_CMS, SET_CMS_DATA, UPDATE_CMS } from "types/actions/cmsMaster.action";

export const getCms = (search: string, page: number, limit: number) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios  
      .get("pages", {
        params: {
  searchTerm: search,
  page,     
  limit,
}
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());

          dispatch({
            type: GET_CMS,
            payload: {
              cms: response.data.data.data,
              count: response.data.data.total,
            },
          });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};


export const createCMS = (payload: any) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .post(`/pages`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: CREATE_CMS, payload: response.data });
        } else {
          dispatch(fetchError("Failed to create cms"));
        }
        return response; 
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};

export const getCmsDetail = (pageId: string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    jwtAxios
      .get(`/pages/${pageId}`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: SET_CMS_DATA, payload: response.data.data });
        } else {
          dispatch(fetchError("Something went wrong, Please try again!"));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const updateCms = (pageId: string | number, payload: any) => {
  return (dispatch: Dispatch<AppActions>): Promise<AxiosResponse<any>> => {
    dispatch(fetchStart());

    return jwtAxios
      .put(`/pages/${pageId}`, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: UPDATE_CMS, payload: response.data });
        } else {
          dispatch(fetchError("Failed to update cms"));
        }
        return response;
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
        return Promise.reject(error);
      });
  };
};


